// Country name normalization and flag mapping
const countryMap: { [key: string]: { name: string; flag: string } } = {
    // Pakistan variations
    'pk': { name: 'Pakistan', flag: '🇵🇰' },
    'PK': { name: 'Pakistan', flag: '🇵🇰' },
    'Pk': { name: 'Pakistan', flag: '🇵🇰' },
    'pK': { name: 'Pakistan', flag: '🇵🇰' },
    'pakistan': { name: 'Pakistan', flag: '🇵🇰' },
    'Pakistan': { name: 'Pakistan', flag: '🇵🇰' },
    'PAKISTAN': { name: 'Pakistan', flag: '🇵🇰' },

    // United States variations
    'us': { name: 'United States', flag: '🇺🇸' },
    'US': { name: 'United States', flag: '🇺🇸' },
    'Us': { name: 'United States', flag: '🇺🇸' },
    'uS': { name: 'United States', flag: '🇺🇸' },
    'usa': { name: 'United States', flag: '🇺🇸' },
    'USA': { name: 'United States', flag: '🇺🇸' },
    'united states': { name: 'United States', flag: '🇺🇸' },
    'United States': { name: 'United States', flag: '🇺🇸' },
    'UNITED STATES': { name: 'United States', flag: '🇺🇸' },

    // United Kingdom variations
    'uk': { name: 'United Kingdom', flag: '🇬🇧' },
    'UK': { name: 'United Kingdom', flag: '🇬🇧' },
    'Uk': { name: 'United Kingdom', flag: '🇬🇧' },
    'uK': { name: 'United Kingdom', flag: '🇬🇧' },
    'united kingdom': { name: 'United Kingdom', flag: '🇬🇧' },
    'United Kingdom': { name: 'United Kingdom', flag: '🇬🇧' },
    'UNITED KINGDOM': { name: 'United Kingdom', flag: '🇬🇧' },
    'great britain': { name: 'United Kingdom', flag: '🇬🇧' },
    'Great Britain': { name: 'United Kingdom', flag: '🇬🇧' },

    // India variations
    'in': { name: 'India', flag: '🇮🇳' },
    'IN': { name: 'India', flag: '🇮🇳' },
    'In': { name: 'India', flag: '🇮🇳' },
    'iN': { name: 'India', flag: '🇮🇳' },
    'india': { name: 'India', flag: '🇮🇳' },
    'India': { name: 'India', flag: '🇮🇳' },
    'INDIA': { name: 'India', flag: '🇮🇳' },

    // Canada variations
    'ca': { name: 'Canada', flag: '🇨🇦' },
    'CA': { name: 'Canada', flag: '🇨🇦' },
    'Ca': { name: 'Canada', flag: '🇨🇦' },
    'cA': { name: 'Canada', flag: '🇨🇦' },
    'canada': { name: 'Canada', flag: '🇨🇦' },
    'Canada': { name: 'Canada', flag: '🇨🇦' },
    'CANADA': { name: 'Canada', flag: '🇨🇦' },

    // Germany variations
    'de': { name: 'Germany', flag: '🇩🇪' },
    'DE': { name: 'Germany', flag: '🇩🇪' },
    'De': { name: 'Germany', flag: '🇩🇪' },
    'dE': { name: 'Germany', flag: '🇩🇪' },
    'germany': { name: 'Germany', flag: '🇩🇪' },
    'Germany': { name: 'Germany', flag: '🇩🇪' },
    'GERMANY': { name: 'Germany', flag: '🇩🇪' },

    // France variations
    'fr': { name: 'France', flag: '🇫🇷' },
    'FR': { name: 'France', flag: '🇫🇷' },
    'Fr': { name: 'France', flag: '🇫🇷' },
    'fR': { name: 'France', flag: '🇫🇷' },
    'france': { name: 'France', flag: '🇫🇷' },
    'France': { name: 'France', flag: '🇫🇷' },
    'FRANCE': { name: 'France', flag: '🇫🇷' },

    // Australia variations
    'au': { name: 'Australia', flag: '🇦🇺' },
    'AU': { name: 'Australia', flag: '🇦🇺' },
    'Au': { name: 'Australia', flag: '🇦🇺' },
    'aU': { name: 'Australia', flag: '🇦🇺' },
    'australia': { name: 'Australia', flag: '🇦🇺' },
    'Australia': { name: 'Australia', flag: '🇦🇺' },
    'AUSTRALIA': { name: 'Australia', flag: '🇦🇺' },

    // Japan variations
    'jp': { name: 'Japan', flag: '🇯🇵' },
    'JP': { name: 'Japan', flag: '🇯🇵' },
    'Jp': { name: 'Japan', flag: '🇯🇵' },
    'jP': { name: 'Japan', flag: '🇯🇵' },
    'japan': { name: 'Japan', flag: '🇯🇵' },
    'Japan': { name: 'Japan', flag: '🇯🇵' },
    'JAPAN': { name: 'Japan', flag: '🇯🇵' },

    // China variations
    'cn': { name: 'China', flag: '🇨🇳' },
    'CN': { name: 'China', flag: '🇨🇳' },
    'Cn': { name: 'China', flag: '🇨🇳' },
    'cN': { name: 'China', flag: '🇨🇳' },
    'china': { name: 'China', flag: '🇨🇳' },
    'China': { name: 'China', flag: '🇨🇳' },
    'CHINA': { name: 'China', flag: '🇨🇳' },

    // Brazil variations
    'br': { name: 'Brazil', flag: '🇧🇷' },
    'BR': { name: 'Brazil', flag: '🇧🇷' },
    'Br': { name: 'Brazil', flag: '🇧🇷' },
    'bR': { name: 'Brazil', flag: '🇧🇷' },
    'brazil': { name: 'Brazil', flag: '🇧🇷' },
    'Brazil': { name: 'Brazil', flag: '🇧🇷' },
    'BRAZIL': { name: 'Brazil', flag: '🇧🇷' },

    // Russia variations
    'ru': { name: 'Russia', flag: '🇷🇺' },
    'RU': { name: 'Russia', flag: '🇷🇺' },
    'Ru': { name: 'Russia', flag: '🇷🇺' },
    'rU': { name: 'Russia', flag: '🇷🇺' },
    'russia': { name: 'Russia', flag: '🇷🇺' },
    'Russia': { name: 'Russia', flag: '🇷🇺' },
    'RUSSIA': { name: 'Russia', flag: '🇷🇺' },

    // South Korea variations
    'kr': { name: 'South Korea', flag: '🇰🇷' },
    'KR': { name: 'South Korea', flag: '🇰🇷' },
    'Kr': { name: 'South Korea', flag: '🇰🇷' },
    'kR': { name: 'South Korea', flag: '🇰🇷' },
    'south korea': { name: 'South Korea', flag: '🇰🇷' },
    'South Korea': { name: 'South Korea', flag: '🇰🇷' },
    'SOUTH KOREA': { name: 'South Korea', flag: '🇰🇷' },
    'korea': { name: 'South Korea', flag: '🇰🇷' },
    'Korea': { name: 'South Korea', flag: '🇰🇷' },

    // Italy variations
    'it': { name: 'Italy', flag: '🇮🇹' },
    'IT': { name: 'Italy', flag: '🇮🇹' },
    'It': { name: 'Italy', flag: '🇮🇹' },
    'iT': { name: 'Italy', flag: '🇮🇹' },
    'italy': { name: 'Italy', flag: '🇮🇹' },
    'Italy': { name: 'Italy', flag: '🇮🇹' },
    'ITALY': { name: 'Italy', flag: '🇮🇹' },

    // Spain variations
    'es': { name: 'Spain', flag: '🇪🇸' },
    'ES': { name: 'Spain', flag: '🇪🇸' },
    'Es': { name: 'Spain', flag: '🇪🇸' },
    'eS': { name: 'Spain', flag: '🇪🇸' },
    'spain': { name: 'Spain', flag: '🇪🇸' },
    'Spain': { name: 'Spain', flag: '🇪🇸' },
    'SPAIN': { name: 'Spain', flag: '🇪🇸' },

    // Netherlands variations
    'nl': { name: 'Netherlands', flag: '🇳🇱' },
    'NL': { name: 'Netherlands', flag: '🇳🇱' },
    'Nl': { name: 'Netherlands', flag: '🇳🇱' },
    'nL': { name: 'Netherlands', flag: '🇳🇱' },
    'netherlands': { name: 'Netherlands', flag: '🇳🇱' },
    'Netherlands': { name: 'Netherlands', flag: '🇳🇱' },
    'NETHERLANDS': { name: 'Netherlands', flag: '🇳🇱' },

    // Sweden variations
    'se': { name: 'Sweden', flag: '🇸🇪' },
    'SE': { name: 'Sweden', flag: '🇸🇪' },
    'Se': { name: 'Sweden', flag: '🇸🇪' },
    'sE': { name: 'Sweden', flag: '🇸🇪' },
    'sweden': { name: 'Sweden', flag: '🇸🇪' },
    'Sweden': { name: 'Sweden', flag: '🇸🇪' },
    'SWEDEN': { name: 'Sweden', flag: '🇸🇪' },

    // Norway variations
    'no': { name: 'Norway', flag: '🇳🇴' },
    'NO': { name: 'Norway', flag: '🇳🇴' },
    'No': { name: 'Norway', flag: '🇳🇴' },
    'nO': { name: 'Norway', flag: '🇳🇴' },
    'norway': { name: 'Norway', flag: '🇳🇴' },
    'Norway': { name: 'Norway', flag: '🇳🇴' },
    'NORWAY': { name: 'Norway', flag: '🇳🇴' },

    // Denmark variations
    'dk': { name: 'Denmark', flag: '🇩🇰' },
    'DK': { name: 'Denmark', flag: '🇩🇰' },
    'Dk': { name: 'Denmark', flag: '🇩🇰' },
    'dK': { name: 'Denmark', flag: '🇩🇰' },
    'denmark': { name: 'Denmark', flag: '🇩🇰' },
    'Denmark': { name: 'Denmark', flag: '🇩🇰' },
    'DENMARK': { name: 'Denmark', flag: '🇩🇰' },

    // Finland variations
    'fi': { name: 'Finland', flag: '🇫🇮' },
    'FI': { name: 'Finland', flag: '🇫🇮' },
    'Fi': { name: 'Finland', flag: '🇫🇮' },
    'fI': { name: 'Finland', flag: '🇫🇮' },
    'finland': { name: 'Finland', flag: '🇫🇮' },
    'Finland': { name: 'Finland', flag: '🇫🇮' },
    'FINLAND': { name: 'Finland', flag: '🇫🇮' },

    // Switzerland variations
    'ch': { name: 'Switzerland', flag: '🇨🇭' },
    'CH': { name: 'Switzerland', flag: '🇨🇭' },
    'Ch': { name: 'Switzerland', flag: '🇨🇭' },
    'cH': { name: 'Switzerland', flag: '🇨🇭' },
    'switzerland': { name: 'Switzerland', flag: '🇨🇭' },
    'Switzerland': { name: 'Switzerland', flag: '🇨🇭' },
    'SWITZERLAND': { name: 'Switzerland', flag: '🇨🇭' },

    // Austria variations
    'at': { name: 'Austria', flag: '🇦🇹' },
    'AT': { name: 'Austria', flag: '🇦🇹' },
    'At': { name: 'Austria', flag: '🇦🇹' },
    'aT': { name: 'Austria', flag: '🇦🇹' },
    'austria': { name: 'Austria', flag: '🇦🇹' },
    'Austria': { name: 'Austria', flag: '🇦🇹' },
    'AUSTRIA': { name: 'Austria', flag: '🇦🇹' },

    // Belgium variations
    'be': { name: 'Belgium', flag: '🇧🇪' },
    'BE': { name: 'Belgium', flag: '🇧🇪' },
    'Be': { name: 'Belgium', flag: '🇧🇪' },
    'bE': { name: 'Belgium', flag: '🇧🇪' },
    'belgium': { name: 'Belgium', flag: '🇧🇪' },
    'Belgium': { name: 'Belgium', flag: '🇧🇪' },
    'BELGIUM': { name: 'Belgium', flag: '🇧🇪' },

    // Ireland variations
    'ie': { name: 'Ireland', flag: '🇮🇪' },
    'IE': { name: 'Ireland', flag: '🇮🇪' },
    'Ie': { name: 'Ireland', flag: '🇮🇪' },
    'iE': { name: 'Ireland', flag: '🇮🇪' },
    'ireland': { name: 'Ireland', flag: '🇮🇪' },
    'Ireland': { name: 'Ireland', flag: '🇮🇪' },
    'IRELAND': { name: 'Ireland', flag: '🇮🇪' },

    // Poland variations
    'pl': { name: 'Poland', flag: '🇵🇱' },
    'PL': { name: 'Poland', flag: '🇵🇱' },
    'Pl': { name: 'Poland', flag: '🇵🇱' },
    'pL': { name: 'Poland', flag: '🇵🇱' },
    'poland': { name: 'Poland', flag: '🇵🇱' },
    'Poland': { name: 'Poland', flag: '🇵🇱' },
    'POLAND': { name: 'Poland', flag: '🇵🇱' },

    // Czech Republic variations
    'cz': { name: 'Czech Republic', flag: '🇨🇿' },
    'CZ': { name: 'Czech Republic', flag: '🇨🇿' },
    'Cz': { name: 'Czech Republic', flag: '🇨🇿' },
    'cZ': { name: 'Czech Republic', flag: '🇨🇿' },
    'czech republic': { name: 'Czech Republic', flag: '🇨🇿' },
    'Czech Republic': { name: 'Czech Republic', flag: '🇨🇿' },
    'CZECH REPUBLIC': { name: 'Czech Republic', flag: '🇨🇿' },
    'czech': { name: 'Czech Republic', flag: '🇨🇿' },
    'Czech': { name: 'Czech Republic', flag: '🇨🇿' },

    // Hungary variations
    'hu': { name: 'Hungary', flag: '🇭🇺' },
    'HU': { name: 'Hungary', flag: '🇭🇺' },
    'Hu': { name: 'Hungary', flag: '🇭🇺' },
    'hU': { name: 'Hungary', flag: '🇭🇺' },
    'hungary': { name: 'Hungary', flag: '🇭🇺' },
    'Hungary': { name: 'Hungary', flag: '🇭🇺' },
    'HUNGARY': { name: 'Hungary', flag: '🇭🇺' },

    // Romania variations
    'ro': { name: 'Romania', flag: '🇷🇴' },
    'RO': { name: 'Romania', flag: '🇷🇴' },
    'Ro': { name: 'Romania', flag: '🇷🇴' },
    'rO': { name: 'Romania', flag: '🇷🇴' },
    'romania': { name: 'Romania', flag: '🇷🇴' },
    'Romania': { name: 'Romania', flag: '🇷🇴' },
    'ROMANIA': { name: 'Romania', flag: '🇷🇴' },

    // Bulgaria variations
    'bg': { name: 'Bulgaria', flag: '🇧🇬' },
    'BG': { name: 'Bulgaria', flag: '🇧🇬' },
    'Bg': { name: 'Bulgaria', flag: '🇧🇬' },
    'bG': { name: 'Bulgaria', flag: '🇧🇬' },
    'bulgaria': { name: 'Bulgaria', flag: '🇧🇬' },
    'Bulgaria': { name: 'Bulgaria', flag: '🇧🇬' },
    'BULGARIA': { name: 'Bulgaria', flag: '🇧🇬' },

    // Croatia variations
    'hr': { name: 'Croatia', flag: '🇭🇷' },
    'HR': { name: 'Croatia', flag: '🇭🇷' },
    'Hr': { name: 'Croatia', flag: '🇭🇷' },
    'hR': { name: 'Croatia', flag: '🇭🇷' },
    'croatia': { name: 'Croatia', flag: '🇭🇷' },
    'Croatia': { name: 'Croatia', flag: '🇭🇷' },
    'CROATIA': { name: 'Croatia', flag: '🇭🇷' },

    // Slovenia variations
    'si': { name: 'Slovenia', flag: '🇸🇮' },
    'SI': { name: 'Slovenia', flag: '🇸🇮' },
    'Si': { name: 'Slovenia', flag: '🇸🇮' },
    'sI': { name: 'Slovenia', flag: '🇸🇮' },
    'slovenia': { name: 'Slovenia', flag: '🇸🇮' },
    'Slovenia': { name: 'Slovenia', flag: '🇸🇮' },
    'SLOVENIA': { name: 'Slovenia', flag: '🇸🇮' },

    // Slovakia variations
    'sk': { name: 'Slovakia', flag: '🇸🇰' },
    'SK': { name: 'Slovakia', flag: '🇸🇰' },
    'Sk': { name: 'Slovakia', flag: '🇸🇰' },
    'sK': { name: 'Slovakia', flag: '🇸🇰' },
    'slovakia': { name: 'Slovakia', flag: '🇸🇰' },
    'Slovakia': { name: 'Slovakia', flag: '🇸🇰' },
    'SLOVAKIA': { name: 'Slovakia', flag: '🇸🇰' },

    // Lithuania variations
    'lt': { name: 'Lithuania', flag: '🇱🇹' },
    'LT': { name: 'Lithuania', flag: '🇱🇹' },
    'Lt': { name: 'Lithuania', flag: '🇱🇹' },
    'lT': { name: 'Lithuania', flag: '🇱🇹' },
    'lithuania': { name: 'Lithuania', flag: '🇱🇹' },
    'Lithuania': { name: 'Lithuania', flag: '🇱🇹' },
    'LITHUANIA': { name: 'Lithuania', flag: '🇱🇹' },

    // Latvia variations
    'lv': { name: 'Latvia', flag: '🇱🇻' },
    'LV': { name: 'Latvia', flag: '🇱🇻' },
    'Lv': { name: 'Latvia', flag: '🇱🇻' },
    'lV': { name: 'Latvia', flag: '🇱🇻' },
    'latvia': { name: 'Latvia', flag: '🇱🇻' },
    'Latvia': { name: 'Latvia', flag: '🇱🇻' },
    'LATVIA': { name: 'Latvia', flag: '🇱🇻' },

    // Estonia variations
    'ee': { name: 'Estonia', flag: '🇪🇪' },
    'EE': { name: 'Estonia', flag: '🇪🇪' },
    'Ee': { name: 'Estonia', flag: '🇪🇪' },
    'eE': { name: 'Estonia', flag: '🇪🇪' },
    'estonia': { name: 'Estonia', flag: '🇪🇪' },
    'Estonia': { name: 'Estonia', flag: '🇪🇪' },
    'ESTONIA': { name: 'Estonia', flag: '🇪🇪' },

    // Greece variations
    'gr': { name: 'Greece', flag: '🇬🇷' },
    'GR': { name: 'Greece', flag: '🇬🇷' },
    'Gr': { name: 'Greece', flag: '🇬🇷' },
    'gR': { name: 'Greece', flag: '🇬🇷' },
    'greece': { name: 'Greece', flag: '🇬🇷' },
    'Greece': { name: 'Greece', flag: '🇬🇷' },
    'GREECE': { name: 'Greece', flag: '🇬🇷' },

    // Portugal variations
    'pt': { name: 'Portugal', flag: '🇵🇹' },
    'PT': { name: 'Portugal', flag: '🇵🇹' },
    'Pt': { name: 'Portugal', flag: '🇵🇹' },
    'pT': { name: 'Portugal', flag: '🇵🇹' },
    'portugal': { name: 'Portugal', flag: '🇵🇹' },
    'Portugal': { name: 'Portugal', flag: '🇵🇹' },
    'PORTUGAL': { name: 'Portugal', flag: '🇵🇹' },

    // Luxembourg variations
    'lu': { name: 'Luxembourg', flag: '🇱🇺' },
    'LU': { name: 'Luxembourg', flag: '🇱🇺' },
    'Lu': { name: 'Luxembourg', flag: '🇱🇺' },
    'lU': { name: 'Luxembourg', flag: '🇱🇺' },
    'luxembourg': { name: 'Luxembourg', flag: '🇱🇺' },
    'Luxembourg': { name: 'Luxembourg', flag: '🇱🇺' },
    'LUXEMBOURG': { name: 'Luxembourg', flag: '🇱🇺' },

    // Malta variations
    'mt': { name: 'Malta', flag: '🇲🇹' },
    'MT': { name: 'Malta', flag: '🇲🇹' },
    'Mt': { name: 'Malta', flag: '🇲🇹' },
    'mT': { name: 'Malta', flag: '🇲🇹' },
    'malta': { name: 'Malta', flag: '🇲🇹' },
    'Malta': { name: 'Malta', flag: '🇲🇹' },
    'MALTA': { name: 'Malta', flag: '🇲🇹' },

    // Cyprus variations
    'cy': { name: 'Cyprus', flag: '🇨🇾' },
    'CY': { name: 'Cyprus', flag: '🇨🇾' },
    'Cy': { name: 'Cyprus', flag: '🇨🇾' },
    'cY': { name: 'Cyprus', flag: '🇨🇾' },
    'cyprus': { name: 'Cyprus', flag: '🇨🇾' },
    'Cyprus': { name: 'Cyprus', flag: '🇨🇾' },
    'CYPRUS': { name: 'Cyprus', flag: '🇨🇾' },

    // Default for unknown countries
    'unknown': { name: 'Unknown', flag: '🌍' },
    'Unknown': { name: 'Unknown', flag: '🌍' },
    'UNKNOWN': { name: 'Unknown', flag: '🌍' },
};

export function normalizeCountry(country: string): { name: string; flag: string } {
    if (!country) {
        return countryMap['unknown'];
    }

    const normalized = country.trim().toLowerCase();
    return countryMap[normalized] || { name: country, flag: '🌍' };
}

export function getCountryDisplay(country: string): string {
    const normalized = normalizeCountry(country);
    return `${normalized.flag} ${normalized.name}`;
}
